import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 通知按钮 */
const NoticeButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

NoticeButton.defaultProps = {
  icon: ICON_COLLECTION.NOTICE,
  text: '通知',
};

export default NoticeButton;
